"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultHeightForEmbedCodeByUnit = exports.getHeightWithUnitsForEmbedCode = exports.getDefaultEmbedCodeOptions = void 0;
var types_1 = require("./EmbedInsightDialogBase/types");
/**
 * @internal
 */
exports.getDefaultEmbedCodeOptions = function (codeType) {
    if (codeType === "definition") {
        return {
            type: "definition",
            includeConfiguration: true,
            customHeight: true,
        };
    }
    return {
        type: "reference",
        displayTitle: true,
        customHeight: true,
    };
};
/**
 * @internal
 */
exports.getHeightWithUnitsForEmbedCode = function (codeOption) {
    var unit = codeOption.unit ? codeOption.unit : "px";
    var customHeightValue = codeOption.height
        ? codeOption.height
        : exports.getDefaultHeightForEmbedCodeByUnit(unit);
    var height = codeOption.customHeight ? customHeightValue : exports.getDefaultHeightForEmbedCodeByUnit(unit);
    if (unit === "px") {
        return Number(height);
    }
    return "" + height + unit;
};
/**
 * @internal
 */
exports.getDefaultHeightForEmbedCodeByUnit = function (unit) {
    return types_1.DEFAULT_HEIGHT[unit];
};
//# sourceMappingURL=utils.js.map